import { getPreview } from 'modules/ATS/action.js'

import { connect } from 'react-redux'
import JobPreviewIndex from '..'
import selectors from '../../ATS/selector'
import {
  CloseRole,
  getCandidateMetrics,
  getJobRoleCandidateList,
  getJobRolePreview,
  getPlacementHistoryList,
  getStudentPlacedList,
  getOneRoleExports,
  completeRole,
  getJobRoleCandidateAppliedList
} from '../action'
import { duplicateRole } from '../../Roles/actions'
import selector from '../selector'
import { getExportFiledData, exportCandidate } from '../../JobRoles/actions'
import { getAppliedCollegesList } from '../../Roles/actions'

const mapStateToProps = state => ({
  previewData: selectors.getPreviewData(state),
  jobRolePreviewData: selector.getJobRolePreview(state),
  getJobRoleCandidateList: selector.getCandidateListList(state),
  getCandidateMetricsData: selector.getCandidateMetrics(state),
  instituteCampusId: "b22d5208-290b-4191-bee4-6d1820c0cd7f",
})

const mapDispatchToProps = {
  getPreview,
  getJobRolePreview,
  getJobRoleCandidateList,
  getCandidateMetrics,
  CloseRole,
  getPlacementHistoryList,
  getExportFiledData,
  exportCandidate,
  getStudentPlacedList,
  getOneRoleExports,
  duplicateRole,
  completeRole,
  getJobRoleCandidateAppliedList,
  getAppliedCollegesList
}

export default connect(mapStateToProps, mapDispatchToProps)(JobPreviewIndex)
